import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Doughnut, Bar, getElementAtEvent } from "react-chartjs-2";
import { bucketTopN } from "./_shared/bucketTopN";
import CustomLegend from "./_shared/CustomLegend";
import ChartState from "./_shared/ChartState";
import { donutOptions, barOptions } from "./_shared/chartTheme";

const DiamondReportsClarityComp = ({ data, loading, onSliceClick }) => {
  const { t } = useTranslation();
  const [chartType, setChartType] = useState("doughnut");
  const chartRef = useRef();

  const { chartData, colors } = bucketTopN(data || [], {
    labelKey: "Clarity",
    valueKey: "CNT",
    chartLabel: "Clarity",
    othersLabel: t("Others"),
  });
  const rows = chartData.slice(1);

  const handleClick = (event) => {
    if (!onSliceClick || !chartRef.current) return;
    const [el] = getElementAtEvent(chartRef.current, event);
    if (!el) return;
    const label = rows[el.index]?.[0]?.replace(/\s*\([^)]*\)\s*$/, "");
    if (label && label !== t("Others")) onSliceClick(label);
  };

  const chartJsData = {
    labels: rows.map((row) => row[0]),
    datasets: [
      {
        data: rows.map((row) => row[1]),
        backgroundColor: colors,
        borderColor: "#fff",
        borderWidth: chartType === "doughnut" ? 2 : 0,
        borderRadius: chartType === "bar" ? 4 : 0,
      },
    ],
  };

  return (
    <React.Fragment>
      <div className="edr-panel mt-4">
        <div className="edr-panel-head">
          <label>
            <b> {t("Diamond Clarity Searches")} </b>
          </label>
          <div className="edr-seg">
            <button
              className={chartType === "doughnut" ? "edr-on" : ""}
              onClick={() => setChartType("doughnut")}
            >
              {t("Donut")}
            </button>
            <button
              className={chartType === "bar" ? "edr-on" : ""}
              onClick={() => setChartType("bar")}
            >
              {t("Bar")}
            </button>
          </div>
        </div>
        <div
          className="chart__section"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          {!loading && rows.length > 0 ? (
            <>
              {chartType === "doughnut" && (
                <CustomLegend chartData={chartData} colorData={colors} />
              )}
              <div className="edr-chartwrap edr-tall">
                {chartType === "doughnut" ? (
                  <Doughnut ref={chartRef} data={chartJsData} options={donutOptions} onClick={handleClick} />
                ) : (
                  <Bar ref={chartRef} data={chartJsData} options={barOptions(true)} onClick={handleClick} />
                )}
              </div>
            </>
          ) : (
            <ChartState loading={loading} />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsClarityComp;
